import { render, staticRenderFns } from "./ProcessList.html?vue&type=template&id=4d7050c4&external"
import script from "./ProcessList.ts?vue&type=script&lang=ts&external"
export * from "./ProcessList.ts?vue&type=script&lang=ts&external"
import style0 from "./ProcessList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports